module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, _vm._l((_vm.items), function(i) {
    return _c('v-layout', {
      key: i,
      staticClass: "mt-2 pb-3",
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('p', {
      staticClass: "settings-label subheader text-xs-right"
    }, [_vm._v(_vm._s(i))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pl-4",
      attrs: {
        "xs5": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "name": "input-1",
        "label": "Title Text",
        "id": "testing"
      },
      model: {
        value: (_vm.data.header),
        callback: function($$v) {
          _vm.$set(_vm.data, "header", $$v)
        },
        expression: "data.header"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "name": "input-7-1",
        "label": "Subtitle Text",
        "multi-line": ""
      },
      model: {
        value: (_vm.data.sub_text),
        callback: function($$v) {
          _vm.$set(_vm.data, "sub_text", $$v)
        },
        expression: "data.sub_text"
      }
    }), _vm._v(" "), _c('v-btn', {
      style: ({
        backgroundColor: _vm.styles.general.theme_color_light
      }),
      attrs: {
        "color": "primary",
        "loading": _vm.loading,
        "disabled": _vm.loading,
        "id": _vm.type
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.submitData(_vm.values)
        }
      }
    }, [_vm._v("\n        Save\n        "), _c('span', {
      staticClass: "custom-loader",
      attrs: {
        "slot": "loader"
      },
      slot: "loader"
    }, [_c('v-icon', {
      attrs: {
        "light": ""
      }
    }, [_vm._v("cached")])], 1)])], 1)], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08477615","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Pages/sections/single_block.vue
// module id = 1635
// module chunks = 2